import { Button, ButtonProps, Tooltip } from 'antd';
import React, { ReactNode, useCallback } from 'react';
import styles from './Button.module.scss';

export type SimpleIconButtonProps = ButtonProps & {
  entityName?: string;
  action?: string;
  stopPropagation?: boolean;
  iconButton: ReactNode;
};

export function SimpleIconButton(props: SimpleIconButtonProps) {
  const {
    entityName,
    action,
    onClick,
    iconButton,
    stopPropagation,
    ...others
  } = props;

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (stopPropagation) {
        e.stopPropagation();
      }

      onClick && onClick(e);
    },
    [onClick, stopPropagation],
  );

  return (
    <Tooltip
      placement="top"
      title={action}
      mouseEnterDelay={0.2}
      className={styles.editAction}
    >
      <Button type="link" icon={iconButton} {...others} onClick={handleClick} />
    </Tooltip>
  );
}
